 <app-header></app-header><br><br><br><br>
<div class="fu-profile mt-4 mb-4">
  <div class="d-flex justify-content-between align-items-center mb-4 stepper">
    <div class="step" [class.active]="step === 1">
      <span class="circle">1</span>
      <span class="label">Personal Details</span>
    </div>
    <div class="line"></div>

    <div class="step" [class.active]="step === 2">
      <span class="circle">2</span>
      <span class="label">Address</span>
    </div>
    <div class="line"></div>

    <div class="step" [class.active]="step === 3">
      <span class="circle">3</span>
      <span class="label">Profession</span>
    </div>
    <div class="line"></div>

    <div class="step" [class.active]="step === 4">
      <span class="circle">4</span>
      <span class="label">Upload Documents</span>
    </div>
  </div>
</div><br>

<div class="container mt-4">
  <div class="card shadow padset">
    <form [formGroup]="profileForm">
      <!-- Stepper UI -->

      <!-- Step 1: Personal Details -->
      <div *ngIf="step === 1">
        <div class="header-title">Personal Details</div>

        <div class="text-center mb-4">

          <div class="position-relative d-inline-block">
            <!-- Profile Image / Default Icon -->
            <div
              class="user-icon rounded-circle d-flex align-items-center justify-content-center">
              <img *ngIf="profileImageUrl" [src]="profileImageUrl"
                class="rounded-circle" width="120" height="120" />
              <i *ngIf="!profileImageUrl"
                class="fas fa-user fa-2x text-white"></i>
            </div>

            <!-- Edit Icon -->
            <span
              class="edit-icon bg-primary text-white rounded-circle d-flex align-items-center justify-content-center setbutton"
              (click)="triggerProfileUpload()">
              <i class="fas fa-pen fa-xs"></i>
            </span>

            <!-- Hidden File Input -->
            <input type="file" #profileFileInput style="display: none;"
              accept="image/*"
              (change)="onProfileImageSelected($event)" />
          </div>

        </div>

        <div class="row">
          <div class="col-md-6 mb-3">
            <label>First Name</label>
            <input type="text" class="controlpro" formControlName="fullName"
              placeholder="Enter your first name">
          </div>
          <div class="col-md-6 mb-3">
            <label>Last Name</label>
            <input type="text" class="controlpro" formControlName="lastName"
              placeholder="Enter your last name">
          </div>
          <div class="col-md-6 mb-3">
            <label>Email</label>
            <input type="email" class="controlpro" formControlName="email"
              placeholder="Enter your email address" readonly>
          </div>
          <div class="col-md-6 mb-3">
            <label>Phone Number</label>

            <div class="input-group custom-input-group">
              <span class="input-group-text">+91</span>
              <input type="text"
                class="form-control controlpromobile"
                formControlName="mobileNumber"
                placeholder="Enter your phone number"
                (input)="onInput($event)">
            </div>

          </div>
          <div class="col-md-6 mb-3">
            <label>Gender</label><br />
            <div class="d-flex gender-group mt-2">
              <div class="col-md-4 " style="margin-left: -12px;">
                <label>
                  <input type="radio" formControlName="gender" value="Female">
                  Female
                </label>
              </div>
              <div class="col-md-6">
                <label>
                  <input type="radio" formControlName="gender" value="Male">
                  Male
                </label>
              </div>
            </div>

          </div>

          <div class="col-md-6 mb-3">
            <label>Birth Year</label>
            <select class="controlpro" formControlName="birthYear">
              <option value>Select Your Birth Year</option>
              <option *ngFor="let year of birthYears" [value]="year">{{ year
                }}</option>
            </select>

          </div>
        </div>

        <button type="button" class="btn btn-fuprile setbutton"
          (click)="nextStep()">Continue</button>
      </div>

      <!-- Step 2: Address -->
      <div *ngIf="step === 2">
        <div class="header-title">Address</div>
        <div class="mb-3">
          <label>Address</label>
          <input type="text" class="controlpros" formControlName="address"
            placeholder="Enter your full address">
        </div>
        <div class="row">
          <div class="col-md-6 mb-3">
            <label>Locality</label>

            <input type="text" class="controlpros" formControlName="locality"
              placeholder="Enter your Locality">
          </div>
          <div class="col-md-6 mb-3">
            <label>City</label>
            <!-- <select class="controlpros" formControlName="city">
              <option>Select Your City</option>
            </select> -->
            <ng-select
              class="custom-height-radius"
              [items]="cityDataList"
              bindLabel="name"
              bindValue="id"
              [searchable]="true"
              placeholder="Select Your City"
              [formControlName]="'cityId'"
              (search)="onSearchCity($event)"
              (change)="onCitySelected($event)">
            </ng-select>
          </div>
          <div class="col-md-6 mb-3">
            <label>State</label>
            <!-- <select class="controlpros" formControlName="state">
              <option>Select Your State</option>
            </select> -->
            <ng-select
              class="custom-height-radius"
              [items]="stateList"
              bindLabel="stateName"
              bindValue="stateId"
              formControlName="stateId"
              [searchable]="false"
              [formControlName]="'stateId'"
              [clearable]="false">
            </ng-select>
          </div>
          <div class="col-md-6 mb-3">
            <label>Pincode</label>
            <input type="text" class="controlpros" formControlName="pincode"
              placeholder="Enter your pincode">
          </div>
        </div>
        <div class="d-flex justify-content-center" style="gap: 1rem;">
          <button type="button" class="btn btn-fupriles setbutton"
            (click)="prevStep()">Back</button>
          <button type="button" class="btn btn-fupriles setbutton"
            (click)="nextStep()">Continue</button>
        </div>

      </div>

      <!-- Step 3: Profession -->
      <div *ngIf="step === 3">
        <div class="header-title">Profession</div>
        <div class="row">
          <div class="col-md-6 mb-3">
            <label>Profession</label>
            <select class="controlpros" formControlName="companyProfession">
              <option value>Select Your Profession</option>
              <option value="business">Business</option>
              <option value="service">Service</option>
              <option value="retired">Retired</option>
            </select>

          </div>
          <div class="col-md-6 mb-3">
            <label>Company Name</label>
            <input type="text" class="controlpros"
              formControlName="companyName"
              placeholder="Enter your company name">
          </div>
          <div class="col-12 mb-3">
            <label>Company Address</label>
            <input type="text" class="controlpros"
              formControlName="companyAddress"
              placeholder="Enter company address">
          </div>
          <div class="col-md-6 mb-3">
            <label>Locality</label>

            <input type="text" class="controlpros"
              formControlName="companyLocality"
              placeholder="Enter company Locality">
          </div>
          <div class="col-md-6 mb-3">
            <label>City</label>

            <ng-select
              class="custom-height-radius"
              [items]="cityDataListcom"
              bindLabel="name"
              bindValue="id"
              [searchable]="true"
              placeholder="Select Your City"
              [formControlName]="'companyCityId'"
              (search)="onSearchCitycom($event)"
              (change)="onCitySelectedcom($event)">
            </ng-select>
          </div>
          <div class="col-md-6 mb-3">
            <label>State</label>
            <ng-select
              class="custom-height-radius"
              [items]="stateListcom"
              bindLabel="compamnystateName"
              bindValue="companyStateId"
              formControlName="companyStateId"
              [searchable]="false"
              [formControlName]="'companyStateId'"
              [clearable]="false">
            </ng-select>
          </div>
          <div class="col-md-6 mb-3">
            <label>Pincode</label>
            <input type="text" class="controlpros"
              formControlName="companyPincode" placeholder="Enter pincode">
          </div>
        </div>
        <div class="d-flex justify-content-center" style="gap: 1rem;">
          <button type="button" class="btn btn-fupriles setbutton"
            (click)="prevStep()">Back</button>
          <button type="button" class="btn btn-fupriles setbutton"
            (click)="nextStep()">Continue</button>
        </div>
      </div>

      <!-- Step 4: Upload Documents -->
      <div *ngIf="step === 4">
        <div class="header-title">Upload Documents</div>
          <div class="row uploadsetup">
            <div class="col-md-6 mbs">
              <label>Office ID Number</label>
              <input type="text" class="controlpros"
                formControlName="officeIdNumber"
                placeholder="Enter your office ID number">
            </div>

            <div class="col-md-6 mbs">
              <label class="form-label">Office ID</label>
              <div class="position-relative">
                <div class="custom-file-input-wrapper">
                  <label class="custom-file-label" for="officeIdFileInput">
                    <span class="fileset"> <ng-container
                        *ngIf="selectedOfficeIdFileName.length > 0; else chooseFile">
                        Change file
                      </ng-container>
                      <ng-template #chooseFile>
                        Choose file
                      </ng-template></span> &nbsp; <ng-container
                      *ngIf="selectedOfficeIdFileUrl">
                      <a [href]="selectedOfficeIdFileUrl"
                        target="_blank"
                        download="{{ selectedOfficeIdFileName }}"
                        style="text-decoration: underline; color: #004aad; cursor: pointer;">
                        {{ getFormattedFileName('OfficeIdCard',
                        selectedOfficeIdFileName) }}
                      </a>
                    </ng-container>
                  </label>
                  <input id="officeIdFileInput" type="file" class="d-none"
                    (change)="handleChange($event, 'officeIdDocument')">
                </div>
              </div>

            </div>
          </div>
          <div class="row uploadsetup">
            <div class="col-md-6 mbs">
              <label>Aadhar Card Number</label>
              <input type="text" class="controlpros"
                formControlName="aadharNumber"
                placeholder="Enter your Aadhar number"
                (input)="onAdhar($event)">
            </div>
            <div class="col-md-6 mbs">
              <label class="form-label">Aadhar Card</label>
              <div class="position-relative">
                <div class="custom-file-input-wrapper">
                  <label class="custom-file-label" for="aadharFileInput">

                    <span class="fileset"> <ng-container
                        *ngIf="selectedAadharFileName.length > 0; else chooseFile">
                        Change file
                      </ng-container>
                      <ng-template #chooseFile>
                        Choose file
                      </ng-template></span>&nbsp;
                    <ng-container
                      *ngIf="selectedAadharFileUrl">
                      <a [href]="selectedAadharFileUrl"
                        target="_blank"
                        download="{{ selectedAadharFileName }}"
                        style="text-decoration: underline; color: #004aad; cursor: pointer;">

                        {{ getFormattedFileName('AadharCard',
                        selectedAadharFileName) }}
                      </a>
                    </ng-container>
                  </label>
                  <input id="aadharFileInput" type="file" class="d-none"
                    (change)="handleChange($event, 'aadharDocument')">
                </div>
              </div>
            </div>
          </div>
          <div class="row uploadsetup">
            <div class="col-md-6 mbs">
              <label>Pan Card Number</label>
              <input type="text" class="controlpros" formControlName="panNumber"
                placeholder="Enter your PAN number">
            </div>
            <div class="col-md-6 mbs">
              <label class="form-label">Pan Card</label>
              <div class="position-relative">
                <div class="custom-file-input-wrapper">
                  <label class="custom-file-label" for="panFileInput">

                    <span class="fileset">
                      <ng-container
                        *ngIf="selectedPanFileName.length > 0; else chooseFile">
                        Change file
                      </ng-container>
                      <ng-template #chooseFile>
                        Choose file
                      </ng-template>
                    </span>&nbsp;

                    <ng-container *ngIf="selectedPanFileUrl">
                      <a [href]="selectedPanFileUrl"
                        target="_blank"
                        download="{{ selectedPanFileName }}"
                        style="text-decoration: underline; color: #004aad; cursor: pointer;">
                        {{ getFormattedFileName('PanCard', selectedPanFileName)
                        }}
                      </a>
                    </ng-container>

                  </label>
                  <input id="panFileInput" type="file" class="d-none"
                    (change)="handleChange($event, 'panDocument')">
                </div>
              </div>
            </div>
          </div>


        <div class="d-flex justify-content-center lastsetbutton" style="gap: 1rem;">
          <button type="button" class="btn btn-fupriles setbutton"
            (click)="prevStep()">Back</button>
          <button type="button" class="btn btn-fupriles setbutton"
            (click)="submitForm()">Submit</button>
        </div>

      </div>
    </form>

  </div>
</div><br><br><br><br>
<app-footer></app-footer>
